export default "__VITE_ASSET__O_DvacL5__"